import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { syncPackageAPI } from '../apis';

const useSyncPackage = (payload) => {
  const mutationAction = useMutation({
    mutationFn: syncPackageAPI,
    onSuccess: () => {
      toast.success('Sync package successfully');
      payload?.callbackSuccess();
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error sync package :', error);
    },
  });

  return mutationAction;
};

export default useSyncPackage;
